// src/stone/icons/CentHand2X.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var CentHand2X = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 40",
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M25 2.667a7.333 7.333 0 1 0 0 14.666 7.333 7.333 0 0 0 0-14.666M15.667 10a9.333 9.333 0 1 1 18.666 0 9.333 9.333 0 0 1-18.666 0M.667 19h2.666c1.02 0 2.748.197 4.472.736 1.54.481 3.228 1.281 4.35 2.597h4.512A7.667 7.667 0 0 1 24.333 30v1h-12v-2h9.911a5.67 5.67 0 0 0-5.577-4.667h-5.52l-.3-.426c-.721-1.03-2.087-1.777-3.638-2.262C5.683 21.168 4.156 21 3.333 21h-.666v10.049l10.392 5.195a5.67 5.67 0 0 0 4.2.349l18.136-5.581-.204-.61a4 4 0 0 0-3.794-2.735h-4.064v-2h4.064a6 6 0 0 1 5.692 4.102l.85 2.553-20.091 6.182a7.67 7.67 0 0 1-5.683-.471L.667 32.285z" }),
      /* @__PURE__ */ jsx("path", { d: "M26 7.333v5.334h-2V7.333z" })
    ]
  }
);
var CentHand2X_default = CentHand2X;

export {
  CentHand2X_default
};
